/**
 * Created by esenckewitch on 18.07.2025
 */

const StickersBook = function () {
    cleverapps.EventEmitter.call(this);

    this.load();
};

StickersBook.prototype = Object.create(cleverapps.EventEmitter.prototype);
StickersBook.prototype.constructor = StickersBook;

StickersBook.prototype.load = function (stored) {
    const save = stored || cleverapps.dataLoader.load(DataLoader.TYPES.STICKERS_BOOK_INFO) || {};
    const saveAttention = cleverapps.dataLoader.load(DataLoader.TYPES.STICKERS_BOOK_ATTENTION) || [];

    this.season = typeof save.season === "string" ? save.season : undefined;
    this.version = save.version;
    this.points = save.points || 0;
    this.jokers = save.jokers || 0;
    this.storedCollections = save.collections || [];

    this.unissuedPrizesCollectionsIndexes = [];

    if (save.collections && save.collections.length) {
        for (let i = 0; i < save.collections.length; i++) {
            const value = save.collections[i];

            const isPrizeCollected = (value & 1) === 1;
            const stickerBits = value >> 1;

            const allStickersMask = (1 << StickersCollection.STICKERS_IN_COLLECTION) - 1;
            const isFullyCollected = stickerBits === allStickersMask;

            if (isFullyCollected && !isPrizeCollected) {
                this.unissuedPrizesCollectionsIndexes.push(i);
            }
        }
    }

    this.createCollections(save, saveAttention);
};

StickersBook.prototype.isAvailable = function () {
    return this.season !== undefined && levels.user.checkAvailable(cleverapps.config.availables.STICKERS_BOOK);
};

StickersBook.prototype.needChangeSeason = function () {
    if (!levels.user.checkAvailable(cleverapps.config.availables.STICKERS_BOOK)) {
        return false;
    }

    if (this.season !== undefined && this.season > StickersBook.LAST_SEASON) {
        return true;
    }

    if (this.season === this.calcSeasonIndex()) {
        return false;
    }

    return this.season !== undefined || this.isEnoughBundlesForSeason();
};

StickersBook.prototype.isEnoughBundlesForSeason = function () {
    const nextSeason = this.calcSeasonIndex();
    if (nextSeason > StickersBook.LAST_SEASON) {
        return false;
    }
    return SeasonCollectionsHelper.hasSeasonBundle(nextSeason);
};

StickersBook.prototype.updateSeason = function () {
    if (this.isAvailable()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STICKERS_DAU);

        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STICKERS_COLLECTIONS + this.getCompletedCollectionsAmount(), {
            key: cleverapps.EVENTS.STICKERS_COLLECTIONS
        });
    }

    if (!this.needChangeSeason()) {
        return;
    }

    const isFirstFeatureAppearance = this.season === undefined;
    const actions = [];

    if (!isFirstFeatureAppearance) {
        actions.push((f) => {
            new StickersBookSeasonWindow({ isCompleted: true });
            cleverapps.focusManager.onceNoWindowsListener = f;
        });

        const unissuedPrizes = this.getUnissuedPrizes();
        if (unissuedPrizes && unissuedPrizes.length) {
            actions.push((f) => {
                new RewardWindow(unissuedPrizes, { event: cleverapps.EVENTS.EARN.STICKERS_BOOK });
                cleverapps.focusManager.onceNoWindowsListener = f;
            });
        }
    }

    if (!this.isEnoughBundlesForSeason()) {
        actions.push((f) => {
            this.setSeason(undefined);
            cleverapps.toolbar.updateItems(true);

            f();
        });
    } else {
        actions.push((f) => {
            this.setSeason(this.calcSeasonIndex());
            cleverapps.toolbar.updateItems(true);
            f();
        });

        actions.push((f) => {
            cleverapps.tutorial.startScenario(cleverapps.tutorial.findScenario(SeasonCollectionsStartTutorial.NAME));
            f();
        });

        if (isFirstFeatureAppearance) {
            actions.push((f) => {
                cleverapps.tutorial.startScenario(cleverapps.tutorial.findScenario(StickersBookStartTutorial.NAME));
                f();
            });
        }
    }

    cleverapps.focusManager.display({
        focus: "StickersBookUpdateSeason",
        actions
    });
};

StickersBook.prototype.setSeason = function (season) {
    this.season = season;
    this.points = 0;
    this.jokers = 0;
    this.storedCollections = [];
    this.createCollections();
    this.save();
};

StickersBook.prototype.createCollections = function (save, saveAttention) {
    save = save || {};
    saveAttention = saveAttention || [];

    this.collections = [];

    this.collectionsAmount = this.calcCollectionsAmount();

    const info = save.collections || [];

    for (let i = 0; i < this.collectionsAmount; i++) {
        const collectionInfo = this.binaryToArray(info[i] || 0, StickersCollection.STICKERS_IN_COLLECTION + 1);
        const isPrizeCollected = Boolean(collectionInfo.pop());
        const collection = new StickersCollection({
            stickers: collectionInfo,
            isPrizeCollected,
            index: i,
            attention: this.binaryToArray(i < saveAttention.length ? saveAttention[i] : 0, StickersCollection.STICKERS_IN_COLLECTION),
            season: this.season
        });

        collection.on("update", () => {
            this.trigger("update");
        });

        this.collections.push(collection);
    }
};

StickersBook.prototype.updateInfo = function (serverData) {
    if (!serverData) {
        return;
    }

    this.load(serverData);
    this.save(true);
};

StickersBook.prototype.updateAttention = function (data) {
    this.collections.forEach((collection, index) => {
        const info = this.binaryToArray(index < data.length ? data[index] : 0, StickersCollection.STICKERS_IN_COLLECTION);
        collection.updateAttention(info);
    });
};

StickersBook.prototype.getAvailableCollections = function () {
    return this.collections;
};

StickersBook.prototype.getInfo = function () {
    const collectionsInfo = this.getAvailableCollections().map((collection) => collection.getInfo());
    let collections = collectionsInfo.map((info) => {
        info.stickers.push(info.isPrizeCollected ? 1 : 0);
        return this.arrayToBinary(info.stickers);
    });

    if (!collections.length && this.storedCollections.length) {
        collections = this.storedCollections;
    }

    return {
        season: this.season,
        collections,
        points: this.points,
        jokers: this.jokers,
        version: this.version
    };
};

StickersBook.prototype.getAttentionInfo = function () {
    return this.collections.map((collection) => this.arrayToBinary(collection.getAttentionInfo()));
};

StickersBook.prototype.arrayToBinary = function (array) {
    return array.reduce((acc, curr) => (acc << 1) | curr, 0);
};

StickersBook.prototype.binaryToArray = function (binary, length) {
    const array = [];
    for (let i = 0; i < length; i++) {
        array.unshift(binary & 1);
        binary >>= 1;
    }
    return array;
};

StickersBook.prototype.givePrize = function (amount, sourceEvent) {
    this.newStickers = this.newStickers || [];

    const probabilities = StickersCollection.DROP_PROBABILITIES;
    const pool = Array.from({ length: probabilities.length }, () => []);

    this.getAvailableCollections().forEach((collection) => {
        collection.stickers.forEach((sticker) => {
            pool[sticker.rarity].push(sticker);
        });
    });

    let duplicates = 0;

    for (let i = 0; i < amount; i++) {
        const rarity = PseudoRandom.GET().pickOne(probabilities);
        const sticker = PseudoRandom.GET().choose(pool[rarity].length ? pool[rarity] : pool[0]);

        if (sticker.getState() === Sticker.STATE_OPENED) {
            this.incPoints(1);
            sticker.duplicate = true;
            duplicates++;
        } else {
            sticker.open(sourceEvent);
        }
        this.newStickers.push(sticker);
    }

    if (duplicates > 0) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STICKER_DUPLICATE + sourceEvent, { value: duplicates });
    }

    this.newStickers = this.newStickers.sort((a, b) => (b.rarity < a.rarity ? -1 : 1));
};

StickersBook.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.STICKERS_BOOK_INFO, this.getInfo());
    if (!fromServer) {
        connector.synchronizer.addSendTask("stickersbook");
    }

    cleverapps.dataLoader.save(DataLoader.TYPES.STICKERS_BOOK_ATTENTION, this.getAttentionInfo());
};

StickersBook.prototype.getOpenedStickersAmount = function () {
    let amount = 0;
    this.getAvailableCollections().forEach((collection) => {
        amount += collection.getOpenedStickersAmount();
    });
    return amount;
};

StickersBook.prototype.getCompletedCollectionsAmount = function () {
    return this.collections.filter((collection) => collection.isCompleted).length;
};

StickersBook.prototype.isCompleted = function () {
    return this.collections.filter((collection) => collection.isCollected()).length === this.collectionsAmount;
};

StickersBook.prototype.exchangePointsToJokers = function () {
    const jokers = Math.floor(this.points / StickersCollection.GOAL_POINTS);
    this.points -= jokers * StickersCollection.GOAL_POINTS;
    this.trigger("updatePoints");
    return jokers;
};

StickersBook.prototype.addJokers = function (amount) {
    amount = amount || 1;
    this.jokers += amount;
    this.trigger("updateJokersAmount", this.jokers);
    this.save();
};

StickersBook.prototype.isFullPoints = function () {
    return this.points >= StickersCollection.GOAL_POINTS;
};

StickersBook.prototype.incPoints = function (amount) {
    this.points += amount;
    this.trigger("updatePoints");
    this.save();
};

StickersBook.prototype.useJoker = function () {
    this.jokers--;
    this.trigger("updateJokersAmount", this.jokers);
    this.save();
};

StickersBook.prototype.hasAttention = function () {
    return this.collections.filter((collection) => collection.hasAttention()).length;
};

StickersBook.isPuzzle = function () {
    return ["wooden"].includes(cleverapps.config.ui);
};

StickersBook.prototype.getUnissuedPrizes = function () {
    if (!this.isEnoughBundlesForSeason() && this.unissuedPrizesCollectionsIndexes.length) {
        return this.unissuedPrizesCollectionsIndexes.map((collectionIndex) => StickersBook.getCollectionReward(collectionIndex));
    }

    return this.collections
        .filter((collection) => collection.isCompleted && !collection.isPrizeCollected)
        .map((collection) => StickersBook.getCollectionReward(collection.index));
};

StickersBook.getCollectionReward = function (collectionIndex) {
    return RewardsConfig.StickersBook[collectionIndex % RewardsConfig.StickersBook.length];
};

StickersBook.prototype.calcCollectionsAmount = function () {
    let collectionsAmount = 0;
    while (SeasonCollectionsHelper.hasCollectionBundle(collectionsAmount, this.season)) {
        collectionsAmount++;
    }

    return collectionsAmount;
};

StickersBook.prototype.getLevelReward = function () {
    const StickersBookLevelRewards = {
        "hard": 3,
        "default": 1
    };
    return Game.currentGame.getNormalizedLevelReward(StickersBookLevelRewards, "match3");
};

StickersBook.prototype.calcSeasonIndex = function () {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const seasonIndex = Math.floor(month / StickersBook.MONTHS_PER_SEASON);

    return `${year}_${seasonIndex}`;
};

StickersBook.prototype.getSeasonTimeLeft = function () {
    if (!this.season) {
        return;
    }

    const now = new Date();

    const [yearStr, seasonStr] = this.season.split("_");
    const year = parseInt(yearStr, 10);
    const season = parseInt(seasonStr, 10);

    const startMonth = season * StickersBook.MONTHS_PER_SEASON;
    const endMonth = startMonth + StickersBook.MONTHS_PER_SEASON;

    const endDate = new Date(year, endMonth, 1);

    return endDate.getTime() - now.getTime();
};

StickersBook.prototype.collectionBundle = function (collectionIndex) {
    return SeasonCollectionsHelper.getCollectionBundleName(collectionIndex, this.season);
};

StickersBook.MONTHS_PER_SEASON = 2;

StickersBook.LAST_SEASON = "2026_3";

StickersBook.PRODUCTS = ["stickers2", "stickers1", "stickers0"];

StickersBook.FULL_PROGRESS_REWARD = [{ joker: 1 }];

cleverapps.InitByFeature["season_collections"] = function () {
    cleverapps.stickersBook = new StickersBook();

    if (cleverapps.toolModel) {
        ToolModel.AUTONAVIGATE.push({
            windows: ["StickersBook"],
            path: ["stickersBook"]
        });
    }

    cleverapps.tutorial.register(StickersBookStartTutorial());
    cleverapps.tutorial.register(SeasonCollectionsStartTutorial());
    cleverapps.tutorial.register(StickersBookJokerTutorial());
};

StickersBook.STICKER_POSITION = {
    x: { align: "center" },
    y: { align: "center" }
};
